<template>
  <div class="panel flex granary-panel">
    <div
      class="item-box"
      v-for="item in pplist"
      :key="item.item_name"
      @click="previewClick"
    >
      <div class="item">
        <img class="logo" :src="item.img" alt="" />
        <div class="r-box">
          <div>{{ item.item_name }}</div>
          <div>
            <span class="num">{{ item.value }}</span> ({{ item.unit }})
          </div>
        </div>
      </div>
    </div>
    <div class="bg-box"></div>
    <div class="y-box" @click="previewClick">
      <img src="~images/granary/pp/center-bg.png" alt="" />
      <div class="info-box">
        <div style="color:#F3D013">
          <span class="num">{{ sfqVal }}</span> {{ sfqUnit }}
        </div>
        <div class="title">总产值</div>
      </div>
    </div>

    <image-preview2
      :show.sync="imgpre"
      :list="imglist"
      :initialIndex="initialIndex"
      :isVideo="true"
      :videoUrl="videoUrl"
    ></image-preview2>
  </div>
</template>

<script>
// import { getDpPagePanel } from "@/api/granary";
import { getDpDataItemByCode } from "@/api/granary";
const imagePreview2 = () => import("@/components/imagePreview2");
export default {
  components: { imagePreview2 },
  data() {
    return {
      sfqVal: "9144361",
      sfqUnit: "万元",
      pplist: [
        {
          name: "种植业产值",
          num: 4953413,
          unit: "万元",
          img: require("images/granary/pp/yjncp.png"),
        },
        {
          name: "林业产值",
          num: 557345,
          unit: "万元",
          img: require("images/granary/pp/wgh.png"),
        },
        {
          name: "牧业产值",
          num: 2346071,
          unit: "万元",
          img: require("images/granary/pp/lssp.png"),
        },
        {
          name: "渔业产值",
          num: 1032333,
          unit: "万元",
          img: require("images/granary/pp/ppncp.png"),
        },
        {
          name: "农林牧渔服务业产值",
          num: 255199,
          unit: "万元",
          img: require("images/granary/pp/ppncp.png"),
        },
        // {
        //   name: "有机农产品",
        //   num: 16,
        //   unit: "个",
        //   img: require("images/granary/pp/yjncp.png")
        // },
        // {
        //   name: "无公害农产品",
        //   num: 9,
        //   unit: "个",
        //   img: require("images/granary/pp/wgh.png")
        // },
        // {
        //   name: "绿色食品",
        //   num: 8,
        //   unit: "个",
        //   img: require("images/granary/pp/lssp.png")
        // },
        // {
        //   name: "名牌农产品",
        //   num: 16,
        //   unit: "个",
        //   img: require("images/granary/pp/ppncp.png")
        // }
      ],
      imgpre: false,
      initialIndex: 0,
      imglist: [],
      videoUrl: window.__config.VUE_APP_IMG_URL + "/upload/mmlz4.mp4",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getDpDataItemByCode({ pagePanelCode: "haneaiuangin" }).then((res) => {
        if (res) {
          let pplist = [];
          res.forEach((ele) => {
            if (/总产值/.test(ele.item_name)) {
              this.sfqVal = ele.value;
              this.sfqUnit = ele.unit;
            }

            if (/种植业产值/.test(ele.item_name)) {
              ele.img = require("images/granary/pp/yjncp.png");
              pplist.push(ele);
            } else if (/林业产值/.test(ele.item_name)) {
              ele.img = require("images/granary/pp/wgh.png");
              pplist.push(ele);
            } else if (/牧业产值/.test(ele.item_name)) {
              ele.img = require("images/granary/pp/lssp.png");
              pplist.push(ele);
            } else if (/渔业产值/.test(ele.item_name)) {
              ele.img = require("images/granary/pp/ppncp.png");
              pplist.push(ele);
            }
          });

          res.forEach((ele) => {
            if (/农林牧渔服务业产值/.test(ele.item_name)) {
              ele.img = require("images/granary/pp/ppncp.png");
              pplist.push(ele);
            }
          });

          this.pplist = pplist;
        }
      });
    },
    // getData() {
    //   getDpPagePanel("ppcj").then(res => {
    //     this.sfqUnit = res[2].unit;
    //     this.sfqVal = res[2].value;
    //     this.pplist[0].unit = res[0].unit;
    //     this.pplist[1].unit = res[3].unit;
    //     this.pplist[2].unit = res[1].unit;
    //     this.pplist[3].unit = res[4].unit;
    //     this.pplist[0].num = res[0].value;
    //     this.pplist[1].num = res[3].value;
    //     this.pplist[2].num = res[1].value;
    //     this.pplist[3].num = res[4].value;
    //   });
    // },
    previewClick() {
      this.imgpre = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  justify-content space-between
  flex-direction row
  flex-wrap wrap
  height 100%
  width 100%
  position relative
  .item-box
    cursor pointer
  div.item-box:nth-child(1)
    top 50px
    left 22px
  div.item-box:nth-child(2)
    top 50px
    right 22px
  div.item-box:nth-child(3)
    bottom 16px
    left 30px
  div.item-box:nth-child(4)
    bottom 16px
    right 30px
  div.item-box:nth-child(5)
    top 10px
    left 50%
    width 160px
    margin-left -80px
    .item
      width 160px
  .bg-box
    position absolute
    top 60%
    left 50%
    transform: translate(-50%,-50%);
    width 230px
    height 112px
    background url('~images/granary/pp/c-bg.png') no-repeat
    background-size 100% 100%
  .y-box
    position absolute
    top 62%
    left 50%
    transform: translate(-50%,-50%);
    // background url('~images/granary/pp/center-bg.png') no-repeat
    // background-size 100% 100%
    display flex
    align-items center
    justify-content center
    flex-direction column
    color white
    cursor pointer
    img
      width 180px
      height 180px
      -webkit-animation round_animate 8s linear infinite
      animation round_animate 8s linear infinite
    .info-box
      position absolute
      text-align center
      z-index 100
      .num
        font-size 18px
      .title
        margin 4px 38px
        text-align center
  .item-box
    // width 33.4%
    // align-items center
    // justify-content center
    width 124px
    height 55px
    display flex
    z-index 1
    position absolute
    .item
        width 124px
        height 55px
        background url('~images/granary/pp/nav-bg.png') no-repeat
        background-size 100% 100%
        display flex
        align-items center
        .logo
            display block
            margin-left 10px
            margin-top 4px
        .r-box
            flex 1
        .num
            color $textColor
            font-size 18px
@keyframes round_animate
  to
    transform rotate(1turn)
</style>
